import type { IApplicationCore } from 'entries/base/interfaces/application-core';
import { getApplicationCore } from 'entries/base/services/application-core/app';

export const App: Partial<IApplicationCore> = getApplicationCore();
